import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer dans le fichier prisma l'enum SyncGmbStatus
export enum SyncGmbStatus {
  NEVER_SYNCHRONIZED = 'NEVER_SYNCHRONIZED',
  SYNCHRONIZING = 'SYNCHRONIZING',
  SYNCHRONIZED = 'SYNCHRONIZED',
  ERROR = 'ERROR',
}

export const GOOGLE_ACCOUNT_STATUS_MAP = {
  [SyncGmbStatus.NEVER_SYNCHRONIZED]: 'cfixe-light-grey-border',
  [SyncGmbStatus.SYNCHRONIZING]: 'cfixe-blue-button',
  [SyncGmbStatus.SYNCHRONIZED]: 'cfixe-light-green',
  [SyncGmbStatus.ERROR]: 'cfixe-light-red',
};

export const GOOGLE_TRANSLATE_KEY = 'SYNC_GOOGLE_STATUS_';

export const SyncGmbStatusTranslation = {
  'fr-FR': {
    [`${GOOGLE_TRANSLATE_KEY}${SyncGmbStatus.NEVER_SYNCHRONIZED}`]: 'Synchronisation en attente',
    [`${GOOGLE_TRANSLATE_KEY}${SyncGmbStatus.SYNCHRONIZING}`]: 'En cours de synchronisation',
    [`${GOOGLE_TRANSLATE_KEY}${SyncGmbStatus.SYNCHRONIZED}`]: 'Synchronisé',
    [`${GOOGLE_TRANSLATE_KEY}${SyncGmbStatus.ERROR}`]: 'Erreur de synchronisation',
  },
};

/**
 * Résultat du push d'UN champ Cfixe vers une fiche Google, persisté par fiche dans
 * `google_location.push_status`. Granularité par champ volontaire : un `locations.patch`
 * groupé peut réussir pendant que `locations.updateAttributes` (lien de RDV) est refusé
 * par la catégorie de la fiche — un statut global afficherait « OK » dans ce cas.
 *
 * Pas un enum Prisma : stocké en JSON, aucune migration d'enum à prévoir.
 */
export enum GmbPushFieldStatus {
  /** Envoyé à Google et accepté. */
  OK = 'OK',
  /** Rien à envoyer (donnée source absente ou inexploitable) — voir `GmbPushSkipReason`. */
  SKIPPED = 'SKIPPED',
  /** Google a refusé la valeur (catégorie incompatible, format invalide…). */
  REJECTED = 'REJECTED',
  /** Champ activé mais jamais parti depuis l'activation. */
  NEVER_PUSHED = 'NEVER_PUSHED',
}

/** Pourquoi un champ activé n'a rien eu à envoyer. Message actionnable côté pro. */
export enum GmbPushSkipReason {
  /** La donnée source est vide côté Cfixe (description, téléphone…). */
  NO_SOURCE_VALUE = 'NO_SOURCE_VALUE',
  /** `opening_hours` ne contient aucune plage exploitable (format invalide / vide). */
  NO_VALID_OPENING_HOURS = 'NO_VALID_OPENING_HOURS',
  /** La fiche Google n'est rattachée à aucun lieu : pas d'horaires à en tirer. */
  NOT_LINKED_TO_PLACE = 'NOT_LINKED_TO_PLACE',
  /** Aucun site web réel (ni domaine custom actif, ni site builder publié). */
  NO_WEBSITE = 'NO_WEBSITE',
}

export const GMB_PUSH_SKIP_REASON_TRANSLATE_KEY = 'GMB_PUSH_SKIP_REASON_';

export const GmbPushSkipReasonTranslation = {
  'fr-FR': {
    [`${GMB_PUSH_SKIP_REASON_TRANSLATE_KEY}${GmbPushSkipReason.NO_SOURCE_VALUE}`]:
      'Renseignez d’abord cette information pour pouvoir l’envoyer.',
    [`${GMB_PUSH_SKIP_REASON_TRANSLATE_KEY}${GmbPushSkipReason.NO_VALID_OPENING_HOURS}`]:
      'Vos horaires ne contiennent aucune plage exploitable : corrigez-les dans l’onglet Informations.',
    [`${GMB_PUSH_SKIP_REASON_TRANSLATE_KEY}${GmbPushSkipReason.NOT_LINKED_TO_PLACE}`]:
      'Cette fiche Google n’est rattachée à aucun lieu.',
    [`${GMB_PUSH_SKIP_REASON_TRANSLATE_KEY}${GmbPushSkipReason.NO_WEBSITE}`]:
      'Publiez votre site ou branchez un nom de domaine pour pouvoir l’envoyer à Google.',
  },
};

/** Agrégat du dernier push d'une fiche, dérivé des statuts par champ. */
export enum GmbPushStatus {
  /** Aucun champ activé, ou jamais poussé. */
  NEVER = 'NEVER',
  OK = 'OK',
  /** Une partie des champs est passée, une autre a été refusée. */
  PARTIAL = 'PARTIAL',
  ERROR = 'ERROR',
}

/**
 * Fraîcheur de la lecture de la fiche Google pour l'aperçu « différences ».
 * L'onglet reste utilisable dans TOUS ces états : les réglages ne sont jamais pris en otage
 * par une lecture Google en échec, seule la colonne de comparaison disparaît.
 */
export enum GmbPreviewReadStatus {
  /** Instantané frais (ou servi depuis le cache court). */
  OK = 'OK',
  /** Google injoignable, mais on affiche le dernier instantané connu. */
  STALE = 'STALE',
  /** Google injoignable et aucun instantané en cache : pas de comparaison possible. */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Compte Google en erreur (token révoqué) — aucun appel n'est tenté. */
  ACCOUNT_ERROR = 'ACCOUNT_ERROR',
  /** La fiche n'existe plus côté Google. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
  /** Fiche sans compte Google rattaché. */
  NOT_CONNECTED = 'NOT_CONNECTED',
}

//DONT TOUCH below this line
validateEnumTranslations(SyncGmbStatus, SyncGmbStatusTranslation, GOOGLE_TRANSLATE_KEY, true);
validateEnumTranslations(GmbPushSkipReason, GmbPushSkipReasonTranslation, GMB_PUSH_SKIP_REASON_TRANSLATE_KEY, true);
